import { useLocation } from 'react-router-dom';
import querystring from 'querystring';

interface Config {
  VEH: string;
  EXC: string;
  WHL: string;
  INT: string;
  PKG: string;
  ORDER: string | undefined;
  CONFIG_NUM: string | undefined;
  APPONLY: string | undefined;
  WAITLIST: string | undefined;
  REFERRAL_CODE: string | undefined;
  APP_GOBACK_FROM: 'model' | 'options' | 'summary' | undefined;
  FF91_SUBSCRIBE: string | undefined;
  ENTRY_PAGE: string | undefined;
  CURRENT_OPTION: string | undefined;
}

export default function useConfig(): Config {
  const { search } = useLocation();
  // TODO: Replace with URLSearchParams + polyfill
  const {
    VEH,
    EXC,
    WHL,
    INT,
    PKG,
    ORDER,
    CONFIG_NUM,
    APPONLY,
    WAITLIST,
    REFERRALCODE: REFERRAL_CODE,
    APP_GOBACK_FROM,
    FF91_SUBSCRIBE,
    ENTRY_PAGE,
    CURRENT_OPTION,
  } = querystring.parse(search.replace(/\?/g, ''));

  return {
    VEH,
    EXC,
    WHL,
    INT,
    PKG,
    ORDER,
    CONFIG_NUM,
    APPONLY,
    REFERRAL_CODE,
    WAITLIST,
    APP_GOBACK_FROM,
    FF91_SUBSCRIBE,
    ENTRY_PAGE,
    CURRENT_OPTION,
  } as Config;
}
